import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PriceFilteringRuleAction } from '../priceFilteringRule.action';
import { PriceFilteringRuleTranslator } from '../priceFilteringRule.translator';

type IDependencies = IClientApiDependencySegment;

export const loadPriceFilteringRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PriceFilteringRuleAction.loadList.started),
  mergeMap((params) => {
    return dependencies.api.getPriceFilteringRules().pipe(
      mergeMap((response) => {
        const result = (response.rules ?? []).map(PriceFilteringRuleTranslator.fromApi);

        return [
          PriceFilteringRuleAction.loadList.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          PriceFilteringRuleAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
